import React, { useState, useEffect, useRef } from "react";

import Animate from "../Animate/Animate";
import FixedBanner from "../FixedBanner/FixedBanner";
import Image from "../Image";

import "./Landing.css";

const LEAD_IFRAME_ORIGIN = "https://nxtwave-lead.netlify.app";

function useLeadIframeBridge(iframeRef) {
  useEffect(() => {
    const getIframe = () => iframeRef.current;

    function sendParentUrlContext() {
      const iframe = getIframe();
      if (!iframe?.contentWindow) return;
      iframe.contentWindow.postMessage(
        { type: "PARENT_URL_CONTEXT", url: window.location.href },
        LEAD_IFRAME_ORIGIN
      );
    }

    function sendUtmToChild() {
      const iframe = getIframe();
      if (!iframe?.contentWindow) return;
      const q = new URLSearchParams(window.location.search);
      const payload = {
        utm_source: q.get("utm_source") || "",
        utm_medium: q.get("utm_medium") || "",
        utm_campaign: q.get("utm_campaign") || "",
        utm_term: q.get("utm_term") || "",
        utm_content: q.get("utm_content") || "",
        gclid: q.get("gclid") || "",
        fbclid: q.get("fbclid") || "",
      };
      iframe.contentWindow.postMessage(
        { type: "UTM_PARAMS", payload },
        LEAD_IFRAME_ORIGIN
      );
    }

    function onMessage(event) {
      if (event.origin !== LEAD_IFRAME_ORIGIN) return;

      if (event.data?.type === "DATALAYER_UPDATE") {
        window.dataLayer = window.dataLayer || [];
        const { payload } = event.data;
        if (Array.isArray(payload)) {
          payload.forEach((item) => {
            if (item && typeof item === "object") window.dataLayer.push(item);
          });
        } else if (payload && typeof payload === "object") {
          window.dataLayer.push(payload);
        }
        return;
      }

      const iframe = getIframe();
      if (!iframe?.contentWindow || event.source !== iframe.contentWindow) {
        return;
      }

      if (event.data?.type === "REQUEST_PARENT_UTM") sendUtmToChild();
      if (event.data?.type === "REQUEST_PARENT_URL_CONTEXT") {
        sendParentUrlContext();
      }
    }

    let loadTimeouts = [];

    function onIframeLoad() {
      sendUtmToChild();
      sendParentUrlContext();
      loadTimeouts.push(setTimeout(sendUtmToChild, 500));
      loadTimeouts.push(setTimeout(sendParentUrlContext, 500));
    }

    const iframe = getIframe();
    if (!iframe) return undefined;

    iframe.addEventListener("load", onIframeLoad);
    window.addEventListener("message", onMessage);

    sendUtmToChild();
    sendParentUrlContext();

    return () => {
      loadTimeouts.forEach(clearTimeout);
      iframe.removeEventListener("load", onIframeLoad);
      window.removeEventListener("message", onMessage);
    };
  }, [iframeRef]);
}

function useInView(ref) {
  const [displayStatus, setDisplayStatus] = useState("none");

  useEffect(() => {
    const element = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setDisplayStatus(entry.isIntersecting ? "none" : "block");
      },
      { threshold: 0.01 }
    );

    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [ref]);

  return displayStatus;
}

export default function EnglishLandingV2() {
  const refA = useRef();
  const leadIframeRef = useRef(null);
  const isInViewA = useInView(refA);
  useLeadIframeBridge(leadIframeRef);

  return (
    <>
      <section
        className="english-landing-v2"
        ref={refA}
        style={{
          overflow: "hidden",
        }}
      >
        <div className="div_block_2">
          <div className="div_block_3">
            <h1 className="heading">
              A Proven Program To
              <br /> Get You a <Animate englishV2 />
            </h1>
            <picture>
              <source
                media="(max-width:479px)"
                loading="lazy"
                srcSet="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/underline_job_mobile.png"
              />
              <Image
                loading="lazy"
                src="https://d14qv6cm1t62pm.cloudfront.net/ccbp-website/intensive/underline_job_desktop.png"
                style={{ width: "auto" }}
                alt="underline-job"
              />
            </picture>
            <div className="ul_par">
              <div className="item">
                <div className="list_icon" />
                <div className="list_text">
                  <span>Trainers</span> are from Amazon and Microsoft
                </div>
              </div>
              <div className="item">
                <div className="list_icon" />
                <div className="list_text">
                  Placement opportunities from a pool of{" "}
                  <span>3000+ companies</span>
                </div>
              </div>
              <div className="item">
                <div className="list_icon" />
                <div className="list_text">
                  <span>10+ Real-time projects</span> that make your
                  <br />
                  resume strong
                </div>
              </div>
              <div className="item">
                <div className="list_icon" />
                <div className="list_text ">
                  AI-Powered <span> Mock Interviews</span>
                </div>
              </div>
            </div>
          </div>
          <div className="div_block_4" id="book-my-session">
            <div className="form_bg_hc_bd">
              <div className="form_bg_hc"> </div>
            </div>
            <div style={{ width: "450px" }}>
              <iframe
                ref={leadIframeRef}
                id="lead-iframe"
                title="Book a free session"
                src="https://nxtwave-lead.netlify.app/"
                width="100%"
                height="600"
                style={{ border: "none", overflow: "hidden" }}
              />
            </div>
          </div>
        </div>
      </section>
      <div className="fixed_s" style={{ display: `${isInViewA}` }}>
        <FixedBanner />
      </div>
    </>
  );
}
